import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { CampusService } from 'src/app/services/campus.service';
import { CampusContactType } from '../../enums/campus-contact-type.enum';
import { Contact } from '../../models/contact.model';
import { Subject, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { CampusPrincipalDialogComponent } from 'src/app/certifications/employment-processing/campus-principal-dialog/campus-principal-dialog.component';
import { takeUntil } from 'rxjs/operators';

interface CampusPrincipalDialogData {
  campusId: number;
  campusName: string;
  principal: Contact;
  service: CampusService;
  contactList: Contact[];
}

@Component({
    selector: 'app-campus-principal-info',
    templateUrl: './campus-principal-info.component.html',
    styleUrls: ['./campus-principal-info.component.scss'],
    standalone: false
})
export class CampusPrincipalInfoComponent implements OnChanges, OnDestroy {

  @Input() campusId: number;
  @Input() campusName: string;

  @Input() principalName: string;
  @Input() principalEmail: string;

  private principalSub: Subscription;
  private destroy$ = new Subject<void>();
  
  principal: Contact;
  contacts: Contact[] = [];
  isLoading: boolean = false;

  constructor(
    private campusService: CampusService,
    private dialog: MatDialog,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.campusId) {

      this.unsubscribePrincipal();

      this.loadPrincipal();

    }
  }

  ngOnDestroy(): void {
    this.unsubscribePrincipal();
    this.destroy$.next();
    this.destroy$.complete();
  }

  private unsubscribePrincipal(): void {
    if (this.principalSub) {
      this.principalSub.unsubscribe();
      this.principalSub = undefined;
    }
  }

  private loadPrincipal(): void {

    if (!this.campusId) {
      this.principal = null;
      this.isLoading = false;
      return;
    }

    this.unsubscribePrincipal();

    this.isLoading = true;
    this.principalSub = this.campusService.getContacts(this.campusId, CampusContactType.Principal)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (contacts: Contact[]) => {
          this.contacts = contacts || [];
          this.principal = contacts && contacts.length > 0 ? contacts[0] : null;
          this.isLoading = false;
        },
        error: (error) => {
          this.principal = null;
          this.isLoading = false;
          console.error('Error fetching principal info:', error);
        }
      });
  }

  private openPrincipalDialog(principal: Contact | null): void {
    const dialogRef = this.dialog.open(CampusPrincipalDialogComponent, {
      data: <CampusPrincipalDialogData> {
        campusId: this.campusId,
        campusName: this.campusName,
        principal: principal,
        service: this.campusService,
        contactList: this.contacts,
      }
    });

    dialogRef.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        this.loadPrincipal();
      });
  }
  
  public addPrincipal(): void {
    this.openPrincipalDialog(null);
  }

  public editPrincipal(): void {
    this.openPrincipalDialog(this.principal);
  }

}
